import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.62 24H2.38A2.38 2.38 0 010 21.62V2.38A2.38 2.38 0 012.38 0h19.24A2.38 2.38 0 0124 2.38v19.24A2.38 2.38 0 0121.62 24z"
          fill="#6595AA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.021 17.971h3.993V5.992H6.021v11.98zM14.007 17.971H18V5.992h-3.993v11.98z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.007 11.982a1.997 1.997 0 11-3.993 0 1.997 1.997 0 013.993 0z"
          fill="#fff"
        />
      </svg>
    </>
  ),
  'Handin',
  '0 0 24 24',
);
